import { Alert } from 'flowbite-react';

export type BadRequestDetail = {
  key?: string | null;
  value?: string | null;
};

export type BadRequestAlertProps = {
  message: string | null;
  details: Array<BadRequestDetail>;
  className?: string;
};

export const BadRequestAlert = ({
  message,
  details,
  className = 'mt-6',
}: BadRequestAlertProps) => {
  if (details.length === 0 && !message) return null;

  return (
    <div className={className}>
      <Alert color="failure">
        <div className="flex flex-col gap-2">
          {message && <span>{message}</span>}
          {details.length > 0 && (
            <ul className="list-inside list-disc space-y-1">
              {details.map((detail, i) => (
                <li key={detail.key ?? i}>{detail.value ?? detail.key}</li>
              ))}
            </ul>
          )}
        </div>
      </Alert>
    </div>
  );
};
